export default __webpack_public_path__ + "static/media/bigs.2c74b215.png";